export default __webpack_public_path__ + "static/media/gallery_01.ac3b6412.jpg";